import React from 'react';
import { registerUrl } from '../../i18n/environments';
import { StyledDiv, StyledParagraph } from '../../styles/generic/globalStyledComponents';
const stickyHighlightStripB = ({ handleAction, translations }) => {
  return (
    <StyledDiv
      backgroundColor="#FBDD46"
      padding="10px 0"
      onClick={(e) => handleAction(e, '', true, ({ param }) => (window.location.href = '#validate'))}
      style={{
        width: '100%',
        zIndex: '999',
        cursor: 'pointer',
      }}
    >
      <StyledParagraph textAlign="center" color="#000" fontSize="20px">
        {translations[1]}
      </StyledParagraph>
    </StyledDiv>
  );
};

stickyHighlightStripB.displayName = 'stickyHighlightStripB';
export default stickyHighlightStripB;
